module.exports = __webpack_public_path__ + "assets/404.fc3d3c35740ec082083edafb2ed4f2d3.svg";